window.dataLayer = window.dataLayer || [];
window.gtag = function () {
  // GA4 needs the arguments object itself; a rest-parameter array is not recognised.
  window.dataLayer.push(arguments);
};
gtag("js", new Date());
